<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Pré Fatura Receita</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive" style="min-height: 400px">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/prefaturareceita"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="prefatrec_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="prefaturareceita-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 4"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-secondary"
                        v-if="props.rowData.status.valor == 5"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="unidade" slot-scope="props">
                      <span>{{
                        props.rowData.unidade.cd +
                        " - " +
                        props.rowData.unidade.descr
                      }}</span>
                    </template>
                    <template slot="status_integracao_erp" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status_integracao_erp.valor == 1"
                        >{{ props.rowData.status_integracao_erp.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status_integracao_erp.valor == 2"
                        >{{ props.rowData.status_integracao_erp.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status_integracao_erp.valor == 3"
                        >{{ props.rowData.status_integracao_erp.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          v-if="getPermissionFw('prefaturareceita.liberar')"
                          @click="onApprove(props.rowData.prefatrec_id)"
                          v-b-tooltip
                          title="Aprovar"
                          ><i class="fa fa-check"></i
                        ></a>
                        <a
                          v-if="getPermissionFw('prefaturareceita.cancelar')"
                          @click="onDisapprove(props.rowData.prefatrec_id)"
                          v-b-tooltip
                          title="Reprovar"
                          ><i class="fa fa-times"></i
                        ></a>
                        <a
                          v-if="
                            getPermissionFw('prefaturareceita.reenvio') &&
                            props.rowData.status_integracao_erp.valor == 3
                          "
                          @click="onReenvioErp(props.rowData.prefatrec_id)"
                          v-b-tooltip
                          title="Reenviar ERP"
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import ConsultaPreFaturaReceitaFilterBarVue from "./ConsultaPreFaturaReceitaFilterBar.vue";
import PreFaturaReceitaDetalhes from "./ConsultaPreFaturaReceitaDetalhes.vue";

Vue.component("prefaturareceita-detalhes", PreFaturaReceitaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": ConsultaPreFaturaReceitaFilterBarVue,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      statusOptions: [],
      statusRrpOptions: [],
      helpForm: new Form({
        recordCollection: [],
        status: "",
        prefatrec_id: "",
      }),
      form: new Form({
        prefatrec_id: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "N° Pre-Fatura",
          sortField: "tp_pre_fatura",
        },
        {
          name: "tp_pre_fatura.descr",
          title: "Tipo Pre-Fatura",
          sortField: "tp_pre_fatura",
        },
        {
          name: "vlr_pre_fatura",
          title: "Valor Pre Fatura",
          sortField: "vlr_pre_fatura",
        },
        {
          name: "pessoa.pessoa_juridica.razao_social",
          title: "Cliente",
          sortField: "pessoa.pessoa_juridica.razao_social",
        },
        {
          name: "__slot:unidade",
          title: "Unidade",
          sortField: "unidade",
        },
        {
          name: "__slot:status_integracao_erp",
          title: "Status ERP",
          sortField: "status",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_fiscal: data_filter.num_fiscal,
        dt_emissao_ini: data_filter.dt_emissao_ini,
        dt_emissao_fim: data_filter.dt_emissao_fim,
        cliente: data_filter.cliente.value,
        status_erp: data_filter.status_erp.value,
        status: data_filter.status.value,
      };
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.prefatrec_id);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onApprove(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.prefatrec_id = id;

      this.form
        .patch("/api/prefaturareceita/liberar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDisapprove(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.prefatrec_id = id;

      this.form
        .patch("/api/prefaturareceita/cancelar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onReenvioErp(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.prefatrec_id = id;
      this.helpForm
        .patch("/api/prefaturareceita/reenvio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/prefaturareceita/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.statusOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_erp.forEach((obj) => {
            this.statusRrpOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
